import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LanguageGuard } from './guards/language.guard';
import { LoggedInGuard } from './guards/logged-in.guard';
import { ProfileGuard } from './guards/profile.guard';
import { SeoGuard } from './guards/seo.guard';
import { SessionGuard } from './guards/session.guard';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

const routes: Routes = [
  {
    path: 'panel',
    canActivate: [LanguageGuard, SessionGuard],
    loadChildren: () =>
      import('./ui/dashboard-tarjeta/dashboard-tarjeta.module').then(
        (m) => m.DashboardTarjetaModule
      ),
  },
  {
    path: 'latino',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./ui/latino-card/latino-card.module').then(
        (m) => m.LatinoCardModule
      ),
  },
  {
    path: 'not-found',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./ui/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: 'internal-error',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./ui/internal-error/internal-error.module').then(
        (m) => m.InternalErrorModule
      ),
  },
  {
    path: 'not-available',
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./ui/not-available/not-available.module').then(
        (m) => m.NotAvailableModule
      ),
  },
  {
    path: 'dashboard',
    canActivate: [LanguageGuard, SessionGuard, ProfileGuard],
    loadChildren: () =>
      import('./ui/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'register',
    canActivate: [LanguageGuard, LoggedInGuard],
    loadChildren: () =>
      import('./ui/landing-page/landing-page.module').then(
        (m) => m.LandingPageModule
      ),
  },
  {
    path: 'login',
    canActivate: [LanguageGuard, LoggedInGuard],
    loadChildren: () =>
      import('./ui/landing-page/landing-page.module').then(
        (m) => m.LandingPageModule
      ),
  },

  {
    path: ':nombre',
    canActivate: [SeoGuard, LanguageGuard],
    loadChildren: () =>
      import('./ui/public-card/public-card.routing.module').then(
        (m) => m.PublicCardRoutingModule
      ),
  },

  {
    path: '',
    canActivate: [LanguageGuard, LoggedInGuard],
    loadChildren: () =>
      import('./ui/landing-page/landing-page.module').then(
        (m) => m.LandingPageModule
      ),
  },

  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',

      //useHash: false
    }),
  ],
providers: [
//  {provide: LocationStrategy, useClass:  HashLocationStrategy},
  
],
  exports: [RouterModule],
})
export class AppRoutingModule {}
